module.exports = __webpack_public_path__ + "assets/img/35.048bfc80.png";